import { useEffect, useMemo, useState } from 'react'
import { SelectWrapper } from '../wrapper'
import Select from 'react-select'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

export const AccreditationSelector = ({ onChange, value }) => {
  const { t } = useTranslation()
  const [selectedOption, setSelectedOption] = useState({})
  const accreditationOptions = useMemo(() => {
    return [
      { value: 'active', label: 'Si' },
      { value: 'inactive', label: 'No' }
    ]
  }, [])

  const handleChange = (option) => {
    setSelectedOption(option)
    onChange(option)
  }

  useEffect(() => {
    if (!value) {
      setSelectedOption({})
      return
    }

    setSelectedOption(
      accreditationOptions.find(
        (accreditedOption) =>
          accreditedOption.value === value
      ) || {}
    )
  }, [value])
  return (

    <SelectWrapper label='Acreditación'>
      {(styles) => (

        <Select
          placeholder={t('select.one')}
          options={accreditationOptions}
          loadingMessage={() => t('select.loading')}
          value={selectedOption.value ? selectedOption : null}
          styles={styles}
          menuPortalTarget={document.body}
          onChange={handleChange}
        />
      )}
    </SelectWrapper>

  )
}

AccreditationSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string
}
